<script setup lang="ts">
const isDev = import.meta.env.DEV
</script>

<template>
  <nuxt-route-announcer />
  <div>
    <nuxt-layout>
      <nuxt-page />
    </nuxt-layout>
  </div>
  <client-only v-if="isDev">
    <claw-guard />
  </client-only>
</template>
